import React from 'react';
import DataTable from 'datatables.net-react';
import DT from 'datatables.net-dt';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import styles from '../phiosophy.module.css';

DataTable.use(DT);

const Public401kTable = ({ data, loading, onDelete, onEdit }) => {
  if (loading && (!data || data.length === 0)) {
    return <div className={styles.tableLoader}>Loading data...</div>;
  }

  if (!data || data.length === 0) {
    return <div className={styles.noData}>No Public 401k data found.</div>;
  }

  const columns = [
    { data: 'ein', title: 'EIN' },
    { data: 'employer_name', title: 'Employer Name' },
    { data: 'type_of_plan', title: 'Plan Type' },
    { data: 'url', title: 'URL Slug' },
    { data: 'plan_rating', title: 'Plan Rating' },
    { data: 'employer_match_sub_header', title: 'Match Sub-Header' },
    { data: 'employer_match_description', title: 'Match Description' },
    { data: 'employer_match_star_rating', title: 'Match Rating' },
    { data: 'vesting_schedule_sub_header', title: 'Vesting Sub-Header' },
    { data: 'vesting_schedule_description', title: 'Vesting Description' },
    { data: 'vesting_schedule_star_rating', title: 'Vesting Rating' },
    {
      data: 'updatedAt',
      title: 'Last Updated',
      render: (data) => new Date(data).toLocaleDateString(),
    },
    {
      data: null,
      title: 'Action',
      orderable: false,
      render: (data, type, row) => {
        return `
          <div class="${styles.actionCell}">
            <button class="${styles.editButton}" data-id="${row.id}">Edit</button>
            <button class="${styles.deleteButton}" data-id="${row.id}">Delete</button>
          </div>
        `;
      },
    },
  ];

  const handleTableClick = (e) => {
    const target = e.target;
    const id = target.getAttribute('data-id');
    if (!id) return;

    const item = data.find((d) => String(d.id) === id);
    if (!item) return;

    if (target.classList.contains(styles.editButton)) {
      onEdit(item);
    } else if (target.classList.contains(styles.deleteButton)) {
      if (window.confirm('Are you sure you want to delete this row?')) {
        onDelete(id);
      }
    }
  };

  return (
    <div className={styles.tableWrapper} onClick={handleTableClick}>
      <h3 className={styles.tableHeader}>Existing Public 401k Data</h3>
      
      <div className={styles.tableContainer}>
        <DataTable
          data={data}
          columns={columns}
          className={`display ${styles.publicTable}`}
          options={{
            pageLength: 10,
            order: [[11, 'desc']], // Sort by Last Updated by default
            responsive: true,
          }}
        />
      </div>
    </div>
  );
};

export default Public401kTable;
